export default "__VITE_ASSET__Bb8R4d3y__"